// extracted by mini-css-extract-plugin
export default {"star":"styles_star__L+0TA","l":"styles_l__IPnzc","m":"styles_m__wu7sj","s":"styles_s__KNJLv"};